export const environment = {
  production: true,
  apiUrl: 'https://delivery-marmita.herokuapp.com/api',
  productImagesServerUrl: 'https://delivery-marmita.herokuapp.com/api/'
};
